<template>
  <b-modal ref="deleteModal" title="Anmeldung löschen">
    <p class="text-center">

    </p>
    <template slot="modal-footer">
      <b-btn class="mt-3" variant="danger" block @click="send">Bestätigen</b-btn>
      <b-btn class="mt-3" variant="secondary" block @click="hide">Abbrechen</b-btn>
    </template>
  </b-modal>
</template>
<script>
export default {
  name: 'DeleteModal',

  data: function () {
    return {
      index: null,
      id: null,
      name: ''
    }
  },

  methods: {
    show: function (index, registrationId, schoolName) {
      this.id = registrationId
      this.name = schoolName

      this.$refs.deleteModal.show()
    },

    hide () {
      this.$refs.deleteModal.hide()
    },

    send () {
      this.axios.delete('/registrations/' + this.id).then(() => {
        this.$emit('confirmed', this.index)
        this.$refs.deleteModal.hide()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/admin/registration/DeleteModal.vue